module.exports = __webpack_public_path__ + "static/media/draussen.a2db1572.jpg";